import { RegionType } from "../enums/RegionType";
import { OpsysType } from "../enums/OpsysType";
import { UpdateResultDto } from "./UpdateResultDto";
import { LightSelectionType } from "../enums/LightSelectionType";

export interface DeviceDto {
    DeviceGuid: string;
    DeviceName: string;
    Region: RegionType;
    HardwareVersion: string;
    DeviceSerialNumber: string;
    DeviceCalibrationUploadId: number | null;
    ToolKey: string|null;
    ComPort: string;
    CameraDistortionParametersJson: string;
    CameraIntrinsicParametersJson: string;
    CameraOffsetsJson: string;
    CameraParametersJson: string;
    ScreenOffsetsJson: string;
    TabletScreenParametersJson: string;
    TargetScreenParametersJson: string;
    Notes: string;
    ActiveInd: boolean;
    VerifiedVehiclesOnlyInd: boolean;
    UseGyroYPRInd: boolean;
    CenterlineEnabledInd: boolean;
    CenterlineThreshold: number;
    AllowReportDownloadInd: boolean;
    AllowAssistedCalibrationInd: boolean;
    AllowAssistedTargetDisplayInd: boolean;
    AllowSelfCalibrationInd: boolean;
    DetailLog: boolean;
    WheelArchHeightEnabledInd: boolean;
    LightIntensity: LightSelectionType;
    Opsys: OpsysType;
    OsDescription: string;
    OsArchitecture: string;
    CreatedByUserName: string;
    CreatedDt: string;
    UpdatedByUserName: string|null;
    UpdatedDt: string|null;
    DeviceClientVersion: string|null;
    DeviceLastContact: string|null;

    UpdateResult: UpdateResultDto;
}

export interface DeviceGridDto extends DeviceDto {
    // eslint-disable-next-line
    Opsys__Display: string;
    // eslint-disable-next-line
    Region__Display: string;
}

// UI fallback when a device has no usable tolerance; not the entity or column default.
export const CenterlineThresholdDefault = 1.5;